


































import Vue from 'vue';
import UserPage from '../components/UserPage.vue';
import UserFormField from '../components/UserFormField.vue';
import gtInit from '@/common/utils/Gt';
import userClient from '../apis';
import appClient from '../../apis';
import { Type, GeetestValidate, LoginCode } from '../models/Login';
import { getCookie } from '@/common/utils/Http';
import userVuex from '../vuex/common';

const email: string | null = null;
const password: string | null = null;
const geetestValidate: GeetestValidate| null = null;
const callback: string | null = null;

export default Vue.extend({
  mixins: [userVuex],
  components: {
    UserPage,
    UserFormField,
  },
  data() {
    return {
      gtInit,
      initGeetest: false,
      inited: false,
      email,
      password,
      showWarning: false,
      loginLoading: false,
      warningText: '',
      loginType: Type.Email,
      geetestValidate,
      callback,
    };
  },
  methods: {
    doLogin() {
      if (this.initGeetest) {
        return;
      } else {
        if (this.validateEmail(this.email) && this.validatePassword(this.password)) {
          this.showWarning = false;
          this.login();
        }
      }
    },
    login() {
      this.loginLoading = true;
      userClient.login({
        username: this.email,
        password: this.password,
        loginType: this.loginType,
        geetestValidate: this.geetestValidate,
      }).success((r) => {
        switch (r.code) {
          case LoginCode.Ok:
            if (r.account) {
              window.localStorage.setItem('account', JSON.stringify(r.account));
              this.$store.commit('UPDATE_ACCOUNT', r.account);
            }
            if (this.callback) {} else {
              if (r.account && r.account.isCompValid) {
                this.upgradeCheck();
              } else {
                window.location.href = '#/user/auth';
              }
            }
            break;
          case LoginCode.CodeError:
            this.showWarning = true;
            this.warningText = '验证码错误，请重试';
            this.loginLoading = false;
            break;
          case LoginCode.UserNotExist:
            this.showWarning = true;
            this.warningText = '账户不存在，请重试';
            this.loginLoading = false;
            break;
          case LoginCode.PasswordError:
            this.showWarning = true;
            this.warningText = '密码错误，请重试';
            this.loginLoading = false;
            break;
          case LoginCode.LoginTypeNotSupport:
            this.showWarning = true;
            this.warningText = '暂不支持该形式登录';
            this.loginLoading = false;
            break;
          case LoginCode.NeedCode:
            this.showWarning = true;
            this.warningText = '需要验证码';
            this.loginLoading = false;
            break;
          default: 
            this.showWarning = true;
            this.warningText = '系统错误，请重试';
            this.loginLoading = false;
        }
      }).error((r) => {
        this.showWarning = true;
        this.warningText = '系统错误，请刷新重试';
        this.loginLoading = false;
      });
    },
    upgradeCheck() {
      appClient.upgradeCheck({}).success((r) => {
        if (r) {
          window.location.href = '#/user/upgrade';
        } else {
          const ff = 'xxx'
          window.location.href = '#/customer/search';
        }
      });
    },
    validateEmail(email: string | null) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (email === null || email === '') {
        this.showWarning = true;
        this.warningText = '请输入邮箱';
        return false;
      } else if (!re.test(email)) {
        this.showWarning = true;
        this.warningText = '邮箱格式不正确';
        return false;
      } else {
        return true;
      }
    },
    validatePassword(password: string | null) {
      if (password === null || password.length === 0) {
        this.showWarning = true;
        this.warningText = '请输入密码';
        return false;
      } else if (password.length < 6) {
        this.showWarning = true;
        this.warningText = '密码格式不正确';
        return false;
      } else {
        return true;
      }
    },
    initGtCaptcha() {
      /* eslint-disable */
      const that = this;
      userClient
        .getGtCaptcha()
        .success((res) => {
          (window as any).initGeetest({
            gt: res.gt,
            challenge: res.challenge,
            offline: !res.success, // 表示用户后台检测极验服务器是否宕机
            new_captcha: true, // 用于宕机时表示是新验证码的宕机
            product: 'bind',
            width: '260px',
          }, function(captchaObj: any) {
            captchaObj.onReady(function() {
              that.inited = true;
              that.initGeetest = true;
            }).onSuccess(function() {
              const validateData = captchaObj.getValidate();
              that.geetestValidate = { challenge: validateData.geetest_challenge, validate: validateData.geetest_validate, seccode: validateData.geetest_seccode };
              that.login();
            }).onError(function() {
              that.$Message.error('出错啦，请刷新页面进行重试');
            });
            document.getElementById('login')!.addEventListener('click', function() {
              if (that.validateEmail(that.email) && that.validatePassword(that.password)) {
                that.showWarning = false;
                userClient.getLoginStatus({
                  username: that.email,
                  loginType: that.loginType,
                }).success((r) => {
                  if (r) {
                    that.login();
                  } else {
                    captchaObj.verify();
                  }
                });
              }
            });
          });
        }).error((e) => {
          that.inited = true;
        });
    },
  },
  mounted() {
    this.initGtCaptcha();
    if (getCookie('usermail')) {
      this.email = getCookie('usermail');
    }
  },
});
